import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../../atom/TokenAtom';
import {
  EntryListsDto,
  EntryListDto,
  PourListSearchDto,
  PourListDto,
} from '../../model/room.dto';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  pourListStateRecoil,
} from '../../atom/ModalAtom';
import WorkNum from '../../component/WorkNum';
import { socketio } from '../../api/socket.api';
import eventbus from '../../api/eventbus';
import { roomAPI } from '../../api/axiosIndex';
import Input from '../../component/Input';
import Table from '../../component/Table';
import { Icon } from '../../component/Icon';

interface PourListProps {
  pickLineId: number | null;
}

const PourList = ({ pickLineId }: PourListProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(pourListStateRecoil);

  const [date, setDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  });
  const [userNumber, setUserNumber] = useState('');
  const [pourList, setPourList] = useState<PourListDto[]>([]);
  const [isToday, setIsToday] = useState<boolean>(true);

  const getPourList = async () => {
    try {
      const today = new Date();
      const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      if (date === todayDate) {
        setIsToday(true);
      } else {
        setIsToday(false);
      }

      const dto: PourListSearchDto = {
        lineId: Number(pickLineId),
        date: date,
        userNumber: userNumber,
        sort: 'createdAt',
        order: 'desc',
      };
      const { data } = await roomAPI.getPourList(dto);
      setPourList(data.results);
    } catch {}
  };

  useEffect(() => {
    getPourList();
  }, []);

  return (
    <>
      <InputModal
        title="타설 목록"
        onCancel={() => setModalState(false)}
        onlyView={true}
      >
        <RefreshBtn className="img-box" onClick={getPourList}>
          <Icon name="ResetIcon" size="100%" color="#435699" />
        </RefreshBtn>
        <SearchWrap>
          <h3>검색 조건</h3>
          <div className="input-wrap">
            <Input
              type="date"
              width="100%"
              theme="type2"
              value={date}
              setValue={setDate}
            />
            <Input
              placeholder="사번 입력"
              type="text"
              width="100%"
              theme="type2"
              value={userNumber}
              setValue={setUserNumber}
            />
            <SearchBtn onClick={getPourList}>
              <span className="img-box">
                <Icon name="SearchIcon" size="100%" color="#fff" />
              </span>
            </SearchBtn>
          </div>
        </SearchWrap>
        <TableWrap>
          <Table theme="type2" thList={['No', '사번', '타설 시간']}>
            {pourList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.userNumber}</td>
                {isToday && (
                  <td>
                    {item.lastTime === 0 ? '지금막' : `${item.lastTime}분 전`}
                  </td>
                )}
                {!isToday && <td>{item.pouringTime}</td>}
              </tr>
            ))}
          </Table>
        </TableWrap>
      </InputModal>
    </>
  );
};

export default PourList;

const RefreshBtn = styled.button`
  position: absolute;
  top: 22px;
  right: 20px;
  width: 20px;
  height: 20px;
`;

const SearchWrap = styled.div`
  width: 100%;
  margin-top: 12px;
  > h3 {
    font-size: 15px;
    font-weight: 700;
    color: #333;
  }
  .input-wrap {
    margin-top: 8px;
    display: grid;
    grid-template-columns: 140px 1fr 36px;
    gap: 4px;
  }
`;

export const SearchBtn = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.mainColor1};
  border-radius: 4px;
`;

const TableWrap = styled.div`
  margin-top: 8px;
  width: 100%;
  overflow-y: auto;
  max-height: calc(100vh - 260px);
`;
